var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { query, collection, where, limit, getDocs, addDoc, getDoc, doc, updateDoc, deleteDoc } from 'firebase/firestore';
import _ from 'lodash';
import { isAdmin } from '../../utils/admin';
import { shapingPaper } from '../../utils/paper';
var COLLECTION = 'papers';
var PaperRepository = /** @class */ (function () {
    function PaperRepository(args) {
        var _this = this;
        this.existsSameDoi = function (doi) { return __awaiter(_this, void 0, void 0, function () {
            var q, snapshot, ids;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (doi === '') {
                            return [2 /*return*/, null];
                        }
                        q = query(collection(this.firestore, COLLECTION), where('doi', '==', doi), limit(1));
                        return [4 /*yield*/, getDocs(q)];
                    case 1:
                        snapshot = _a.sent();
                        ids = [];
                        snapshot.forEach(function (s) {
                            ids.push(s.id);
                        });
                        return [2 /*return*/, _.isEmpty(ids) ? null : ids[0]];
                }
            });
        }); };
        this.addPaper = function (paper) { return __awaiter(_this, void 0, void 0, function () {
            var shapedPaper, docRef, data, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.uid) {
                            throw new Error('no set uid: login error');
                        }
                        return [4 /*yield*/, this.existsSameDoi(paper.doi)];
                    case 1:
                        // NOTE: トランザクション処理はしていません
                        if (_b.sent()) {
                            throw new Error('same doi exists');
                        }
                        shapedPaper = shapingPaper({ paper: paper, uid: this.uid, isInitial: true });
                        return [4 /*yield*/, addDoc(collection(this.firestore, COLLECTION), shapedPaper)];
                    case 2:
                        docRef = _b.sent();
                        _a = [{ id: docRef.id }];
                        return [4 /*yield*/, getDoc(docRef)];
                    case 3:
                        data = __assign.apply(void 0, _a.concat([(_b.sent()).data()]));
                        return [2 /*return*/, data];
                }
            });
        }); };
        this.editPaper = function (id, paper, uid) { return __awaiter(_this, void 0, void 0, function () {
            var shapedPaper, docRef, data, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.uid) {
                            throw new Error('no set uid: login error');
                        }
                        if (!id) {
                            throw new Error('no set id: paper data error');
                        }
                        // ログイン本人か確認（AdminはOK）
                        if (!(this.uid === uid || isAdmin({ uid: this.uid }))) {
                            throw new Error('uid not match');
                        }
                        shapedPaper = shapingPaper({ paper: paper, uid: uid });
                        docRef = doc(collection(this.firestore, COLLECTION), id);
                        return [4 /*yield*/, updateDoc(docRef, shapedPaper)];
                    case 1:
                        _b.sent();
                        _a = [{ id: docRef.id }];
                        return [4 /*yield*/, getDoc(docRef)];
                    case 2:
                        data = __assign.apply(void 0, _a.concat([(_b.sent()).data()]));
                        return [2 /*return*/, data];
                }
            });
        }); };
        this.deletePaper = function (paper) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.uid) {
                            throw new Error('no logged in: login error');
                        }
                        if (_.isEmpty(paper.uid) || _.isEmpty(paper.id)) {
                            throw new Error('paper data error');
                        }
                        // ログイン本人か確認（AdminはOK）
                        if (!(this.uid === paper.uid || isAdmin({ uid: this.uid }))) {
                            throw new Error('uid not match');
                        }
                        return [4 /*yield*/, deleteDoc(doc(collection(this.firestore, COLLECTION), paper.id))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, {
                                id: paper.id
                            }];
                }
            });
        }); };
        /** @deprecated functionsのgraphql Mutation.updateOutsideRequestStatusを利用して下さい */
        this.outsideRequest = function (paperId) { return __awaiter(_this, void 0, void 0, function () {
            var docRef, updateData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.uid) {
                            throw new Error('no set uid: login error');
                        }
                        if (!paperId) {
                            throw new Error('no set id: paper data error');
                        }
                        docRef = doc(collection(this.firestore, COLLECTION), paperId);
                        updateData = {
                            outsideRequest: true
                        };
                        return [4 /*yield*/, updateDoc(docRef, updateData)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.outside = function (paperId) { return __awaiter(_this, void 0, void 0, function () {
            var docRef, updateData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.uid) {
                            throw new Error('no set uid: login error');
                        }
                        if (!paperId) {
                            throw new Error('no set id: paper data error');
                        }
                        // 管理者のみ実行可能
                        if (!isAdmin({ uid: this.uid })) {
                            throw new Error('did not allowed user');
                        }
                        docRef = doc(collection(this.firestore, COLLECTION), paperId);
                        updateData = {
                            outsideRequest: true,
                            outside: true
                        };
                        return [4 /*yield*/, updateDoc(docRef, updateData)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.inside = function (paperId) { return __awaiter(_this, void 0, void 0, function () {
            var docRef, updateData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.uid) {
                            throw new Error('no set uid: login error');
                        }
                        if (!paperId) {
                            throw new Error('no set id: paper data error');
                        }
                        // 管理者のみ実行可能
                        if (!isAdmin({ uid: this.uid })) {
                            throw new Error('did not allowed user');
                        }
                        docRef = doc(collection(this.firestore, COLLECTION), paperId);
                        updateData = {
                            outsideRequest: false,
                            outside: false
                        };
                        return [4 /*yield*/, updateDoc(docRef, updateData)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.auth = args.auth;
        this.firestore = args.firestore;
        this.uid = this.auth.currentUser ? this.auth.currentUser.uid : null;
    }
    return PaperRepository;
}());
export { PaperRepository };
